module.exports = __webpack_public_path__ + "img/CW.803476d3.svg";